// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const LinkedinIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Linkedin/brand"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.523 2H3.478C2.662 2 2 2.641 2 3.433v17.133C2 21.358 2.662 22 3.478 22h17.045C21.34 22 22 21.358 22 20.566V3.433C22 2.642 21.34 2 20.523 2ZM8.063 18.741H5.042v-9.03h3.021v9.03ZM6.533 8.478h.02c1.053 0 1.708-.693 1.708-1.56-.02-.886-.656-1.56-1.69-1.56-1.033 0-1.709.674-1.709 1.56 0 .867.657 1.56 1.67 1.56Zm12.423 10.263h-3.02v-4.83c0-1.215-.438-2.043-1.53-2.043-.836 0-1.333.559-1.55 1.098-.081.193-.101.462-.101.732v5.043h-3.02s.04-8.183 0-9.03h3.02v1.28c.401-.614 1.118-1.492 2.722-1.492 1.988 0 3.48 1.29 3.48 4.065v5.177Zm-6.163-7.739-.042.061h.042v-.061Z",
  clipRule: "evenodd"
}));
export default LinkedinIcon;